import { Suspense } from "react";
import { Outlet } from "react-router-dom";

export const Layout = () => {
    return (
        <div>
            {/* Extend Layout of the application with other components here */}
            {/* Suspense is used because app pages are lazy loaded */}
            <Suspense>
                <Outlet />
            </Suspense>
        </div>
    );
};
